import { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EditorImg from 'lowcode/components/EditorImg';
import { Navigation, Mousewheel, Scrollbar } from 'swiper';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import 'swiper/css/mousewheel';
import getLocal from '@/app/utils/getLocal';

const First: FC = () => {
    const { t } = useLang('xcode.xfusion.first');
    const { locale } = getLocal();

    let mediaList = [
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701657739/X-fusion.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718701657739/X-fusion.jpg',
        },
    ];
    if (locale === 'uk') {
        mediaList = [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724725462750/AC%20limits_uk.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724725488475/AC%20limits_m_uk.jpg',
            },
        ];
    }

    if (['it', 'de', 'es', 'eu', 'fr'].includes(locale)) {
        mediaList = [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1724725052923/AC%20limits.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1724725475720/AC%20limits_m.jpg',
            },
        ];
    }

    return (
        <div className={styled.First}>
            <div className="media_box">
                <Swiper
                    className="media_swiper"
                    modules={[Navigation, Mousewheel, Scrollbar]}
                    spaceBetween={30}
                    navigation
                    // centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                >
                    {mediaList?.map((item, index) => (
                        <SwiperSlide className="item" key={index}>
                            <div className="media">
                                <EditorImg pc={item.pc} alt={item.pc} h5={item.h5} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="middle-central">
                <div className="text_box">
                    <div className="left font-desc">
                        {t.rich('left', {
                            line: (text: string) => <span>{text}</span>,
                        })}
                    </div>
                    <div className="right font-desc">
                        <div className="right_item">
                            {t.rich('right1', {
                                line: (text: string) => <p>{text}</p>,
                            })}
                        </div>
                        <div className="right_item">
                            {t.rich('right2', {
                                line: (text: string) => <p>{text}</p>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default First;
